import React, { Component } from 'react';
import FooterInner from './FooterInner';

export default class Footer extends Component {
  render() {
    return (
      <footer className="App-footer">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-lg-10 col-lg-push-1 ">
              <FooterInner/>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Footer.js